export const tableColumns = [
  {
    title: '渠道用户名',
    dataIndex: 'channelUserName',
    width: '240px'
  },
  {
    title: '渠道代码',
    dataIndex: 'channelCode',
    width: '180px'
  },
  {
    title: '集团代码',
    dataIndex: 'chainCode',
    width: '160px'
  },
  {
    title: '状态',
    dataIndex: 'statusName',
    width: '100px'
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    width: '180px'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: '140px',
    fixed: 'right',
    scopedSlots: { customRender: 'action' }
  }
]

export const editConfigList = [
  {
    name: '渠道用户名',
    key: 'channelUserName',
    placeholder: '请输入渠道用户名'
  },
  {
    name: '渠道代码',
    key: 'channelCode',
    placeholder: '请输入渠道代码'
  },
  {
    name: '集团代码',
    key: 'chainCode',
    placeholder: '请输入集团代码'
  },
  {
    name: '密钥',
    key: 'key',
    placeholder: '请输入密钥'
  },
  {
    name: ' ',
    key: 'custom',
    slot: true
  }
]

export const ruleRows = [
  {
    label: '建议销售价',
    formulaText: '税后价(LOS总价)',
    configKey: 'salePriceRate',
    valueKey: 'salePriceRate',
    suffix: '%',
    showEnabled: true,
    tip: '销售价大于100%才不会亏损'
  },
  {
    label: '销售价',
    formulaText: '税后价(LOS总价) +',
    configKey: 'salePriceSum',
    valueKey: 'salePriceSum',
    suffix: '￥',
    showEnabled: true,
    tip: ''
  },
  {
    label: '同行价',
    formulaText: '税后价(LOS总价) + (建议销售价-税后价(LOS总价))',
    field: 'peerPriceRate',
    suffix: '%',
    tip: ''
  },
  {
    label: '佣金',
    formulaText: '(建议销售价-税后价(LOS总价))',
    field: 'commissionRate',
    suffix: '%',
    tip: ''
  },
  {
    label: '市场价',
    formulaText: '建议销售价',
    field: null,
    tip: ''
  },
  {
    label: '采购价',
    formulaText: '税后价(LOS总价)',
    field: null,
    tip: ''
  }
]
